module.exports = __webpack_public_path__ + "static/img/bg3.88b7d74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg3.jpg
// module id = KOiA
// module chunks = 1